import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { SmallCardData } from '../../interfaces/card-data';
import { NoDataActionType, NoDataSourceType, NoDataTypes } from '../../interfaces/no-data';
export interface IScorecardDetailsCardData {
    entityIdentifier: string;
    entityAbbr: string;
    action: NoDataActionType;
    hasData: boolean;
    isDataLoading: boolean;
    entity: string;
    scoreCardType: 'employee' | 'third-party' | 'location';
    entityPicture: object;
    entityTopLeftTitle: string;
    entityTopRightTitle: string;
    entityBotLeftTitle: string;
    entityBotRightTitle: string;
    entityTopLeftValue: string;
    entityTopRightValue: string;
    entityBotLeftValue: string;
    entityBotRightValue: string;
    rankTypeTitle: string;
    scoreValue: string;
    scoreValueOutOf: string;
    rankValue: string;
    rankValueOutOf: string;
    productTypeTitle: string;
    productVolumeValue: string;
    productVolumeValueOutOf: string;
    productUnitsValue: string;
    productUnitsValueOutOf: string;
    bottomCards?: SmallCardData[] | Array<object>;
}
@Component({
    selector: 'scorecards-score-summary-card',
    templateUrl: './scorecards-score-summary-card.component.html',
    styleUrls: ['./scorecards-score-summary-card.component.scss'],
})
export class ScorecardsScoreSummaryCardComponent implements OnInit, OnChanges {
    constructor() {}

    isDataLoaded = false;
    hasData = false;
    noDataType: NoDataTypes;
    @Input() rankData: IScorecardDetailsCardData;
    detailsCard: IScorecardDetailsCardData;

    ngOnInit() {}

    ngOnChanges(changes: { [property: string]: SimpleChange }) {
        let change: SimpleChange = changes['rankData'];
        this.setData(change.currentValue);
    }

    setData(cardData: IScorecardDetailsCardData) {
        this.noDataType = {
            inputSource: NoDataSourceType.largeDataCard,
            action: cardData.action,
            showTitle: false,
            searchTerm: '',
            componentTitle: 'scorecard data',
        };
        this.hasData = cardData.hasData;
        this.isDataLoaded = !cardData.isDataLoading;
        this.detailsCard = cardData;
    }
}
